import { Layout } from '~/components/Layout';
import { Toaster } from '~/components/Toast';
import { ErrorBoundary } from '~/modules/errors/components/ErrorBoundary';

import { Router } from './router';

export function App() {
  return (
    <Layout>
      <ErrorBoundary key="settings">
        <Toaster offset="1rem" />
        <Router />
      </ErrorBoundary>
    </Layout>
  );
}

App.displayName = 'SettingsApp';
